import { useState } from "react";
import { useRouter } from "next/router";
import {
  MotionFlex,
  MotionBox,
  MotionImage,
  MotionStack,
  menuScaleHover,
  quickFade,
} from "utils/motion";
import { Flex } from "@chakra-ui/react";
import Button from "components/base/Button";
import Trans from "components/base/Trans";

const NavbarMenuItem = (props) => {
  const { url, label, image, subItem, subItems, onClose, isVisible } = props;
  const router = useRouter();
  const [hovering, setHovering] = useState(false);
  const isSelected = router.pathname === url;

  return (
    <Button
      id={props.id}
      variant="unstyled"
      _hover={{ cursor: "pointer" }}
      _focus={{ bg: "transparent" }}
      _active={{ bg: "transparent" }}
      href={url}
      onClick={onClose}
      onHoverStart={() => setHovering(true)}
      onHoverEnd={() => setHovering(false)}
    >
      <MotionFlex
        variants={{
          hidden: { opacity: 0, x: 25 },
          visible: {
            opacity: 1,
            x: 0,
            transition: { type: "tween", duration: 0.4, delay: props.delay },
          },
        }}
        initial="hidden"
        animate={isVisible ? "visible" : "hidden"}
      >
        {image && (
          <MotionBox
            position="relative"
            mr={["md", "md", "md", "xs", "md", "md"]}
            style={{ overflow: "hidden" }}
            minWidth={["0px", "0px", "0px", "140px", "160px", "224px"]}
            maxHeight={["0px", "0px", "0px", "79px", "90px", "127px"]}
          >
            <MotionBox
              variants={menuScaleHover}
              initial="normal"
              position="relative"
              bg="black.900"
              animate={hovering ? "hover" : "normal"}
            >
              <MotionImage
                w={["0px", "0px", "0px", "140px", "160px", "224px"]}
                h={["0px", "0px", "0px", "79px", "90px", "127px"]}
                src={image}
                objectFit="cover"
              />
            </MotionBox>
          </MotionBox>
        )}
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
        >
          <Button
            small={subItem}
            selected={isSelected || hovering}
            variant="menu"
            _focus={{ bg: "transparent" }}
            _active={{ bg: "transparent" }}
            style={{ textWrap: "wrap", textAlign: "left" }}
          >
            <Trans id={label} />
          </Button>
          {subItems?.length > 0 && (
            <MotionStack
              isInline
              bottom={["-30px", "-30px", "-30px", 0]}
              position="absolute"
              spacing={[2, 2, 4, 8]}
              h="20px"
              variants={quickFade}
              initial="hidden"
              animate={hovering ? "visible" : "hidden"}
            >
              {subItems.map((e) => (
                <Button
                  key={e.id}
                  id={e.id}
                  h="20px"
                  selected={isSelected}
                  _focus={{ bg: "transparent" }}
                  _active={{ bg: "transparent" }}
                  variant="menu"
                  small
                  style={{ textWrap: "wrap", textAlign: "left" }}
                >
                  <Trans id={e.label} />
                </Button>
              ))}
            </MotionStack>
          )}
        </Flex>
      </MotionFlex>
    </Button>
  );
};

export default NavbarMenuItem;
